import React, {useState, useRef} from 'react';
import {
    Box,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Select,
    InputLabel,
    FormControl
} from '@mui/material';
import axios from 'axios';
import blankImage from "./blank.png"
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import DocTypesEnum from "../../../enums/DocTypesEnum";
import JoditEditor from "jodit-react";
import InstructionsBox from "./InstructionsBox";
import DepartmentEnumWithoutLegal from "../../../enums/DepartmentEnumWithoutLegal";
import OrderDecisionEnum from "../../../enums/orderDecisionEnum";
import TemplateEnum from "../../../enums/templateEnum";
import {HiMiniDocumentPlus} from "react-icons/hi2";


export default function HeaderGenerator({onFileAdded}) {
    const [docName, setDocName] = useState('');
    const [approvalDocument, setApprovalDocument] = useState(false);
    const [hasBarCode, setHasBarcode] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [skipVisage, setSkipVisage] = useState(false);
    const [selectedDocType, setSelectedDocType] = useState(null);
    const editor = useRef(null);
    const [content, setContent] = useState('');
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [orderDecision, setOrderDecision] = useState('');
    const [templateType, setTemplateType] = useState(null);

    const TemplateOptions = [
        {id: null, name: 'შაბლონის გარეშე'}, // Add a null option
        {id: TemplateEnum.order, name: 'ბრძანება'},
        {id: TemplateEnum.letter, name: 'წერილი'},
        {id: TemplateEnum.insideLetter, name: 'სამსახურეობრივი ბარათი'},
    ];

    const handleDepartmentChange = (event, departmentId) => {
        if (event.target.checked) {
            setSelectedDepartments(prev => [...prev, departmentId]);
        } else {
            setSelectedDepartments(prev => prev.filter(id => id !== departmentId));
        }
    };

    const handleContentChange = (newContent) => {
        const sylfaenContent = newContent.replace(/font-family:[^;]+;/g, 'font-family: Sylfaen;');
        setContent(sylfaenContent);
    };


    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა",

    };

    const config = {
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 800,
        width: 798,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'link',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
            'symbol',
        ],
        controls: {
            font: {
                list: {
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
        style: {
            cssText: `
            * {
                font-family: 'Sylfaen', sans-serif !important;
            }
        `
        }
    };


    const handleOpenForm = (event) => {
        event.preventDefault();
        setIsModalOpen(true);
    };


    const clearForm = () => {
        setDocName('');
        setOrderDecision('')
        setApprovalDocument(false);
        setHasBarcode(false);
        setSkipVisage(false);
        setSelectedDocType(null);
        setContent('');
        setSelectedDepartments([]);
        setTemplateType(null);
    };

    const handleDocNameChange = (event) => {
        setDocName(event.target.value);
    };

    const handleBarcodeChange = (event) => {
        setHasBarcode(event.target.checked);
    };

    const handelSkipVisageChange = (event) => {
        setSkipVisage(event.target.checked);
    };

    const prepareContent = () => {
        return content.replace(/font-family:.*?;/g, 'font-family: Sylfaen;');
    };

    const handleConfirm = async () => {
        const blankHtml = ``;
        const barcodeHtml = `
       <table class="custom-table" style="width: 800px; border-collapse: collapse; border: none; margin-top: 0">
             <tr style="width: 100%">
       
        <tr style="width: 100%">
            <td id="dateTime" style="width: 400px;  border: none; background-size: cover; ;">
            <img src="${blankImage}" alt="Logo" style="height: 1px; width: 350px; border: none" />
            </td>
        
            <td  style="width: 300px;  border: none;  ">
                <img src=${blankImage} alt="Logo" id="barCode-2" style="width:1px; height: 1px;" />
            </td>
        </tr>
           <tr style="width: 100%">
            <td id="docNumber" style="width: 400px;  border: none; background-size: cover; ;">
            <img src="${blankImage}" alt="Logo" style="height: 1px; width: 350px; border: none" />
            </td>
        
            <td  style="width: 500px;  border: none;  ">
                <img src=${blankImage} alt="Logo" id="barCode-2" style="width:1px; height: 20px;" />
            </td>
        </tr>
   
        </tr>
    </table>
        `
        let combinedHtml;
        if (hasBarCode) {
            combinedHtml = blankHtml + barcodeHtml;
        } else {
            combinedHtml = blankHtml;
        }

        const cleanedContent = prepareContent();

        const postData = {
            name: docName,
            description: "",
            permitTypeId: 7,
            blank: combinedHtml,
            approvalDocument: approvalDocument,
            documentTypeStatus: selectedDocType,
            textHTML: cleanedContent,
            departamentIds: selectedDepartments,
            templateType: templateType,
            orderDecision: selectedDocType === 1 && orderDecision ? orderDecision : null,
            skipVisage: skipVisage
        };
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewDocumentType`, postData);
            onFileAdded();
            clearForm();
            setIsModalOpen(false);
        } catch (error) {
            console.error('Failed to create document type:', error);
        }
    };


    return (
        <div>
            <div>
                <div style={{display: "flex"}}>
                    <form onSubmit={handleOpenForm}>
                        <h1 className="apl-title">შაბლონის შექმნა</h1>
                        <Box>


                            <TextField style={{marginBottom: 16}} fullWidth label="შაბლონის სახელი" variant="outlined"
                                       value={docName}
                                       onChange={handleDocNameChange}/>
                            <FormControl fullWidth sx={{my: 2}}>
                                <InputLabel id="doc-type-label">შაბლონის ტიპი</InputLabel>
                                <Select
                                    labelId="doc-type-label"
                                    id="doc-type-select"
                                    value={templateType}
                                    label="შაბლონის ტიპი"
                                    onChange={(e) => setTemplateType(e.target.value)}
                                >
                                    {TemplateOptions.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth sx={{my: 2}}>
                                <InputLabel id="doc-type-label">დოკუმენტის ტიპი</InputLabel>
                                <Select
                                    labelId="doc-type-label"
                                    id="doc-type-select"
                                    value={selectedDocType}
                                    label="დოკუმენტის ტიპი"
                                    onChange={(e) => setSelectedDocType(e.target.value)}
                                >
                                    {Object.values(DocTypesEnum).map((type) => (
                                        <MenuItem key={type.id} value={type.id}>
                                            {type.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {selectedDocType === 1 && (
                                <FormControl fullWidth sx={{my: 2}}>
                                    <InputLabel id="order-decision-label">დადასტურების ტიპი</InputLabel>
                                    <Select
                                        labelId="order-decision-label"
                                        id="order-decision-select"
                                        value={orderDecision}
                                        label="დადასტურების ტიპი"
                                        onChange={(e) => setOrderDecision(e.target.value)}
                                    >
                                        {Object.values(OrderDecisionEnum).map((decision) => (
                                            <MenuItem key={decision.id} value={decision.id}>
                                                {decision.title}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}


                            <Box style={{width: 800}}>
                                {Object.values(DepartmentEnumWithoutLegal).map(department => (
                                    <FormControlLabel
                                        key={department.id}
                                        control={
                                            <Checkbox
                                                checked={selectedDepartments.includes(department.id)}
                                                onChange={(e) => handleDepartmentChange(e, department.id)}
                                            />
                                        }
                                        label={department.name}
                                    />
                                ))}
                            </Box>
                            <FormControlLabel control={<Checkbox checked={hasBarCode} onChange={handleBarcodeChange}/>}
                                              label="აქვს შტრიხკოდი"/>

                            <FormControlLabel control={<Checkbox checked={skipVisage} onChange={handelSkipVisageChange}/>}
                                              label="ვიზირების გამოტოვება"/>

                            <div id="editor-content">
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    config={config}
                                    tabIndex={1}
                                    onBlur={(newContent) => handleContentChange(newContent)}
                                />
                            </div>
                            <div style={{display: "flex", gap: 5}}>
                                <Button
                                    style={{height: 37, marginTop: 20, width: 300}}
                                    disabled={selectedDocType === null || docName === '' || selectedDepartments.length === 0 || (selectedDocType === 1 && orderDecision === '')}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    endIcon={<HiMiniDocumentPlus style={{verticalAlign: 'middle'}}/>}
                                >
                                    შაბლონის შექმნა
                                </Button>
                            </div>
                        </Box>
                    </form>
                    <InstructionsBox/>
                </div>

            </div>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={handleConfirm}
            />
        </div>
    );
}
